<template>
    <page-base :taxpayerInfo="currentTaxpayer" :moneyPlacementName="moneyPlacementName">
        <template slot="content">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card class="text-right mb-3" no-body style="padding: 1rem 1.25rem;">
                <a href="javascript:" @click="print"><print-icon title="" />&nbsp;{{ $t('general.print') }}</a>
                <a href="javascript:" @click="shortPrint"><print-icon title="" />&nbsp;Печать на терминале</a>
            </b-card>
            <div id="mp">
                <b-alert v-if="currentTaxpayer" variant="info" show class="text-center">
                    <h5>{{ currentTaxpayer.name }}</h5>
                    <hr>
                    <p>
                        {{ `${$t('general.iinbin')}: ${currentTaxpayer.iin}` }}
                        <br>
                        {{ `${$t('kkm.registration')}: ${moneyPlacement.ccmRegistrationNumber || ''}` }}
                        <br>
                        {{ `${$t('kkm.factoryNum')}: ${moneyPlacement.ccmFactoryNumber || ''}` }}
                    </p>
                    <p>
                        {{ moneyPlacement.debet ? $t('moneyPlacement.collection') : $t('moneyPlacement.replenishment') }}
                        <br>
                        {{ `${$t('moneyPlacement.txnClientDate')}: ${$d(moneyPlacement.txnClientDate, 'long')}` }}
                        <br>
                        {{ `${$t('moneyPlacement.shiftDocumentNumber')}: ${moneyPlacement.shiftDocumentNumber || ''}` }}
                    </p>
                </b-alert>
                <b-card>
                    <table class="w-100 mt-3 table table-borderless">
                        <tbody>
                            <tr v-if="hasData">
                                <th class="h4">
                                    {{ moneyPlacement.debet ? $t('moneyPlacement.sumOfCollection') : $t('moneyPlacement.sumOfReplenishment') }}
                                </th>
                                <td align="right" class="h4">{{ moneyPlacement.amount }}&nbsp;&#8376;</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </div>
            <div style="display:none;">
                <div id="short-check" style="padding-top: 1px; display: inline-block;">
                    <div style="background-color: white; height: inherit; padding: 10pt 5pt 1pt 5pt; overflow: auto;">
                        <table>
                            <tbody style="border-width: 0px; empty-cells: show; height: 800pt; width: 271pt; position: relative;">
                                <tr>
                                    <td style="width: 0px; height: 0px"></td>
                                    <td class="width: 0px; height: 0px"></td>
                                    <td class="width: 0px; height: 0px"></td>
                                    <td class="width: 0px; height: 0px"></td>
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: bold; font-style: normal; width: 269px; height: 28pt; line-height: 14px; text-align: left; vertical-align: center;">
                                        <nobr>{{ moneyPlacement.debet ? $t('moneyPlacement.collection') : $t('moneyPlacement.replenishment') }}</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-style: normal; width: 269px; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;">
                                        <nobr>{{ currentTaxpayer.name }}</nobr>
                                    </td>
                                </tr>
                                <tr></tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269px; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;"> 
                                        <nobr>{{ `${$t('general.iinbin')}: ${currentTaxpayer.iin}` }}</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269px; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;"> 
                                        <nobr> {{ $t('kkm.registration') }}:</nobr>
                                    </td>
                                </tr>
                                <tr v-if="moneyPlacement.ccmRegistrationNumber">
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269px; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;"> 
                                        <nobr>{{ moneyPlacement.ccmRegistrationNumber }}</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269px; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;"> 
                                        <nobr>{{ `${$t('kkm.factoryNum') }: ${moneyPlacement.ccmFactoryNumber || ''}` }}</nobr>
                                    </td>
                                </tr>                                
                                <tr><td></td></tr>
                                <tr>
                                    <td colspan="4" style="border-bottom: #000000 1px dashed;"></td> 
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269px; height: 40pt; line-height: 14pt; text-align: left; vertical-align: bottom;"> 
                                        <nobr>Дата:</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269pt; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;"> 
                                        <nobr>{{ $d(moneyPlacement.txnClientDate, 'longTime') }}</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: normal; font-style: normal; width: 269pt; height: 28pt; line-height: 14pt; text-align: left; vertical-align: center;"> 
                                        <nobr>{{$t('moneyPlacement.shiftDocumentNumber')}}: {{moneyPlacement.shiftDocumentNumber}}</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="border-bottom: #000000 1px dashed;"></td> 
                                </tr>
                                <tr>
                                    <td style="padding-bottom: 10pt; color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 16pt; font-weight: bold; font-style: normal; width: 269pt; height: 40pt; line-height: 14pt; text-align: left; vertical-align: bottom;"> 
                                        <nobr>{{ moneyPlacement.debet ? $t('moneyPlacement.sumOfCollection') : $t('moneyPlacement.sumOfReplenishment')}}: {{moneyPlacement.amount}}&nbsp;&#8376;</nobr>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="border-bottom: #000000 1px dashed; height: 160pt; vertical-align: bottom;"></td> 
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </page-base>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'

export default {
    name: 'MoneyPlacementDetails',
    mixins: [ AppData ],
    mounted () {
        this.getCurrentTaxpayer()
    },
    created () {
        this.fetchData()
    },
    data () {
        return {
            moneyPlacement: this.$route.params,
            moneyPlacementData: {}
        }
    },
    computed: {
        breadcrumbs: function () {
            var breadcrumbs = []
            this.$route.meta.breadcrumbs.forEach(element => {
                breadcrumbs.push({ text: this.$t(element.text), to: element.to })
            })
            breadcrumbs.push({
                text: `${this.moneyPlacement.debet
                    ? this.$t('moneyPlacement.collection')
                    : this.$t('moneyPlacement.replenishment')} ${this.$route.params.id}`,
                active: true
            })
            return breadcrumbs
        },
        moneyPlacementName: function () {
            return `${this.moneyPlacement.debet
                ? this.$t('moneyPlacement.collection')
                : this.$t('moneyPlacement.replenishment')}`
        },
        hasData: function () {
            return Object.keys(this.moneyPlacementData).length > 0
        }
    },
    methods: {
        fetchData: function () {
            const data = {
                id: this.$route.params.id,
                dealerId: this.currentTaxpayer 
                    ? this.currentTaxpayer.id 
                    : this.$route.params.dealerId
            };

            const onSuccess = response => {
                if (!Array.isArray(response))
                    throw new Error('Server must be returns array');
                
                if (response.length !== 1){
                    this.$router.push('/error/404');

                    console.error('Get money placements by id must be returns one item');

                    return;
                }

                if (response[0] != null) {
                    const mp = response[0];

                    if (mp.txnClientDate != null)
                        mp.txnClientDate = new Date(mp.txnClientDate);

                    if (mp.data != null)
                        this.moneyPlacementData = JSON.parse(mp.data);
                    
                    this.moneyPlacement = mp;
                }
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.moneyPlacement.get,
                data,
                onSuccess,
                this.displayAlert);
        },
        print: function () {
            this.$htmlToPaper('mp');
        },
        shortPrint() {
            this.$htmlToPaper('short-check');
        }
    }
}
</script>
<style>
.check-container {
    padding-top: 1px;
    display: inline-block;
}

.check-body {
    background-color: white;
    height: inherit;
    padding: 5px 5px 1px 5px;
    overflow: auto;
}

.check-table {
    border-width: 0px;
    empty-cells: show;
    width: 271px;
    /* height: 643px; */
    position: relative;
}

.check-item {
	color: #000000; background-color: transparent; border-left-style: none; border-top-style: none; border-right-style: none; border-bottom-style: none; font-family: Consolas; font-size: 12px; font-weight: bold; font-style: normal; width: 269px; height: 17px; line-height: 14px; text-align: left; vertical-align: center;
}

.check-item-right {
    text-align: right;
}

.check-zero-height {
    height: 0px;
}

.check-zero-width {
    width: 0px;
}

.check-section-separator {
    border-bottom: #000000 1px dashed;
}
</style>
